import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => ({
    progress: {
        margin: theme.spacing(2),
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'block'
    },
}));